<template>
	<div class="text-image">
		<div class="grid grid--g40--desk grid--g20--ltab grid--s40--desk grid--s20--ltab">
			<div class="grid__item" :class="{
					'one-half--not-phab' : image && image.link && displayInColumns		// <attr class='one-half--not-phab' />
				}">

				<div class="text-image__content" >
					<h3 v-if="title" class="text-image__title h3">{{ title }}</h3>
					<div v-if="text" class="text-image__description" v-html="text"></div>
<!--
       		<theme-btn class="btn--shape--h48">Button Action</theme-btn>
-->
				</div>

			</div>
			<div v-if="image && image.link" class="grid__item" :class="{
				'one-half--not-phab' : displayInColumns		// <attr class='one-half--not-phab' />
			}">

				<div class="text-image__image">
					<img :src="image.link" />
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import Btn from "../atoms/Btn";
import ThemeBtn from "../atoms/ThemeBtn";

export default {
	name: 'TextImage',
	components: {
		Btn,
		ThemeBtn
	},
	props: {
		title: {
			type: String,
			default: null
		},
		text: {
			type: String,
			default: null
		},
		image: {
			type: Object,
			default: null
		},
		displayInColumns: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".text-image";
	#{$c}
	{
		color: palette(grey);

		&__description
		{
			line-height: 2;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/TextImage.vue